// Copyright (c) 2017 Deere & Company

import SpaClaims from '../state/spa-claims';
import actions from '../../actions-list';
import {getDefaultState as getWipDefaultState} from '../state';

const updateSpaClaims = (state, action) =>
    SpaClaims.update(state, {
        $set: action.data
    });

export default (state = getWipDefaultState().specialAllowanceClaims, action) => {

    const actionTypes = {
        [actions.UPDATE_TABM_SPA_CLAIMS]: updateSpaClaims
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tabm/wip/reducers/special-allowance-claims.js